// During server-side rendering, there are additional onfocus onblur attributes that get added to the InputField
// used by AutocompleteField. This is a bug in react-hotkeys.
// Because of different attributes, React cannot hydrate properly since the markup is not what it expects.
// This works around the issue by showing the InputField during SSR without any React-hotkeys wrapper.
import React from 'react';
import AutocompleteField from 'eventbrite_design_system/autocompleteField/AutocompleteField';
import InputField from 'eventbrite_design_system/inputField/InputField';

const BareAutocompleteField = ({ placeholder, prefix, disabled }) => (
    <div className="eds-autocomplete-field" data-spec="autocompletefield-field">
        <div className="eds-autocomplete-field__dropdown-holder">
            <InputField
                id="input-field-fallback"
                style="basic"
                label="autocomplete"
                placeholder={placeholder}
                prefix={prefix}
                borderType="none"
                disabled={disabled}
            />
        </div>
    </div>
);

export default class AutocompleteFieldWithFallback extends React.Component {
    state = {
        isInBrowser: false,
    };

    componentDidMount() {
        this.setState({ isInBrowser: true });
    }
    render() {
        return this.state.isInBrowser ? (
            <AutocompleteField {...this.props} />
        ) : (
            <BareAutocompleteField {...this.props} />
        );
    }
}
